import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-img-dialog',
  template: `
  <div style="display:flex;align-items:center;height:100vh;width:100vw"
    (swipeleft)="next()"
    (swiperight)="previous()"
    (click)="dialogRef.close()">
    <img [src]="bypassSecurity(items[index]?.dataUri)" style="width:auto;height:auto;max-width:100%;max-height:100%;margin:auto;">
  </div>`,
})
export class ImageDialogComponent {

  items: { dataUri: string, rowspan: number }[];
  index: number;

  constructor(
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    private _sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: {items: { dataUri: string, rowspan: number }[], index: number}
  ) {
    this.items = data.items;
    this.index = this.data.index || 0;
  }

  next() {
    this.index = this.index + 1 === this.items.length ? 0 : this.index + 1;
  }

  previous() {
    this.index = this.index === 0 ? this.items.length - 1 : this.index - 1;
  }

  bypassSecurity(url: string) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }
}
